import React, { useContext, useEffect, useState } from "react";
import { Modal } from "../modal";
import Card from "canvas-core-react/lib/Card";
import Row from "canvas-core-react/lib/Row";
import Column from "canvas-core-react/lib/Column";
import "./style.scss";
import TextSubtitle from "canvas-core-react/lib/TextSubtitle";
import TextField from "canvas-core-react/lib/TextField";
import Margin from "canvas-core-react/lib/Margin";
import { ButtonCancel } from "../buttonCancel";
import { ButtonOk } from "../buttonOk";
import IconWithdrawIllustrative from "canvas-core-react/lib/IconWithdrawIllustrative";
import { CoachContext } from "../../context";

interface ModalExpenseProps {
  title?: string;
  amount?: string;
  isEdit?: boolean;
  cancelOnClick: () => void;
  onClick: () => void;
}

export const ModalExpense = ({
  title = "",
  amount = "",
  isEdit = false,
  cancelOnClick,
  onClick,
}: ModalExpenseProps) => {
  const [nameExpense, setNameExpense] = useState("");
  const [amountExpense, setAmountExpense] = useState("");
  const [isButtonDisable, setIsButtonDisable] = useState(true);
  const { saveValue, modifyAmount } = useContext(CoachContext);
  const [stateValue, setStateValue] = useState<any>({});
  const [disabledTxt, setDisabledTxt] = useState<boolean>(false);

  useEffect(() => {
    if (nameExpense !== "" && amountExpense !== "") setIsButtonDisable(false);
    else setIsButtonDisable(true);
  }, [nameExpense, amountExpense.replace(/\B(?=(\d{3})+(?!\d))/g, '.')]);

  useEffect(() => {
    setNameExpense(title);
    setAmountExpense(amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
  }, []);

  const handleChange = (event: any) => {

    if (event.target.value === "") {
      setAmountExpense("");
      setStateValue({ name: "input", error: "no puede estar vacío." });
      setIsButtonDisable(true);

    } else {

      let num = parseInt(event.target.value.replaceAll('.', ''));


      if (num.toString().match(/^-?\d*\.?\d*$/)) {
        if (event.target.value.length < 11) {
          setAmountExpense(num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
          setStateValue({ name: "input", error: "" });
          setIsButtonDisable(false);
        }
        else {
          setAmountExpense(num.toString().substring(0, 9).replace(/\B(?=(\d{3})+(?!\d))/g, '.'));
          setStateValue({ name: "input", error: "maximo 9 digitos." });
          setIsButtonDisable(true);
        }
      } else {
        setStateValue({ name: "input", error: "ingrese solo números." });
        setIsButtonDisable(true);

      }

    }
  };
  return (
    <Modal>
      <div className="addExpense">
        <Card>
          <Row>
            <Column xs={1} sm={1} md={1} lg={1}>
              <IconWithdrawIllustrative />
            </Column>
            <Column xs={3} sm={7} md={11} lg={11}>
              <TextSubtitle component="span">
                {isEdit ? "Editar gasto" : "Agregar otro gasto"}
              </TextSubtitle>
            </Column>
          </Row>
          <Margin xs={48} sm={48} md={48} lg={48} side="top">
            <Row>
              <Column xs={4} sm={8} md={12} lg={12}>
                <TextField
                  id="name"
                  label="Nombre"
                  disabled={isEdit}
                  type="string"
                  placeholder=""
                  defaultValue={isEdit ? title : ""}
                  onChange={(event) => setNameExpense(event.target.value)}
                />
              </Column>
            </Row>
          </Margin>
          <Margin xs={48} sm={48} md={48} lg={48}>
            <Row>
              <Column xs={4} sm={8} md={12} lg={12}>
                <TextField
                  id="amount"
                  label="Monto"
                  placeholder="$"
                  defaultValue={isEdit ? amount : ""}
                  onChange={handleChange}
                  disabled={disabledTxt}
                  value={amountExpense}
                />
                <div>{stateValue.error}</div>
              </Column>
            </Row>
          </Margin>
          <Margin xs={48} sm={48} md={48} lg={48} side="top">
            <Row>
              <Column xs={4} sm={8} md={6} lg={6}>
                <ButtonCancel title="Cancelar" onClick={cancelOnClick} />
              </Column>
              <Column xs={4} sm={8} md={6} lg={6}>
                <ButtonOk
                  title={isEdit ? "Editar" : "Agregar"}
                  isLarge={true}
                  onClick={() => {
                    if (isEdit) modifyAmount(nameExpense, amountExpense.replaceAll(".", ""));
                    else
                      saveValue(
                        nameExpense,
                        nameExpense,
                        amountExpense.replaceAll(".", ""),
                        "egresos",
                        "extra"
                      );
                    setDisabledTxt(true);
                    onClick();

                  }}
                  disabled={isButtonDisable}
                />
              </Column>
            </Row>
          </Margin>
        </Card>
      </div>
    </Modal>
  );
};
